import React from "react";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faTwitter, faLinkedin, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <footer className="footer-container text-white py-16 bg-gradient-to-br from-blue-400" style={{ backgroundColor: "#4267B2" }}>
            <div className="container mx-auto flex flex-col lg:flex-row justify-between items-start px-4 mb-16">
                <div className="lg:w-1/2 mb-8 lg:mb-0">
                    <h3 className="text-2xl font-semibold">Subscribe to our newsletter</h3>
                    <p className="text-blue-300 mt-2">Enter your email address to join our mailing list and get our latest updates</p>
                </div>
                <div className="lg:w-1/2 flex justify-end">
                    <div className="flex items-center w-full lg:w-auto bg-blue-800 bg-opacity-10 rounded-lg overflow-hidden">
                        <input type="email" placeholder="Enter your email" className="p-3 w-full lg:w-80 text-white placeholder-white bg-blue-100 bg-opacity-25 placeholder-opacity-40 focus:outline-none" />
                        <button className="p-3 text-white placeholder-white bg-blue-100 bg-opacity-25 focus:outline-none">
                            <FontAwesomeIcon icon={faPaperPlane} />
                        </button>
                    </div>
                </div>
            </div>
            <hr />
            <br />
            <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 px-4 md:px-6">
                <div className="space-y-4 col-span-1 md:col-span-2">
                    <img src="https://www.drishtiias.com/drishti/img/drishti_logo_new_eng.png" alt="Drishti Logo" className="w-20" />
                    <h4 className="text-lg font-semibold">Drishti Learning App</h4>
                    {/* <p className="text-blue-300">
                        Drishti IAS is dedicated to providing unwavering support and expert guidance for UPSC and State Services aspirants across multiple States/Union Territory in India. We also offer comprehensive online programs
                        accessible through our Drishti Learning App (both Android & iOS) and Website, in addition to our well-established physical classroom centers.
                    </p> */}
                    <ul className="space-y-2 text-blue-300">
                        <li>
                            <a href="https://www.drishtilearningapp.com/about-us" className="hover:text-blue-400">
                                About Us
                            </a>
                        </li>
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                Why Choose Us ?
                            </a>
                        </li>
                        <li>
                            <a href="https://www.drishtiias.com/contact" className="hover:text-blue-400">
                                Contact Us
                            </a>
                        </li>
                    
                    </ul>
                </div>

                <div>
                    <h4 className="text-lg font-semibold mb-4">Our Verticals</h4>
                    <ul className="space-y-2 text-blue-300">
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                UPSC
                            </a>
                        </li>
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                State PCS
                            </a>
                        </li>
                        
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                Drishti Judiciary
                            </a>
                        </li>
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                CUET
                            </a>
                        </li>
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                Publication
                            </a>
                        </li>
                        {/* <li><a href="#" className="hover:text-blue-400">All</a></li> */}
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                Teaching Exam
                            </a>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-lg font-semibold mb-4">Drishti Websites</h4>
                    <ul className="space-y-2 text-blue-300">
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                Drishti IAS
                            </a>
                        </li>
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                Drishti Teaching Exams
                            </a>
                        </li>
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                Drishti Judiciary
                            </a>
                        </li>
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                Drishti CUET
                            </a>
                        </li>
                    </ul>

                    <br />
                    <div className="flex space-x-6 text-2xl">
                        <a href="https://www.facebook.com/drishtieng/" className="hover:text-blue-400">
                            <FontAwesomeIcon icon={faFacebook} />
                        </a>
                        <a href="https://twitter.com/drishtiias" className="hover:text-blue-400">
                            <FontAwesomeIcon icon={faTwitter} />
                        </a>
                        <a href="https://www.linkedin.com/in/drishtiiasvideos/" className="hover:text-blue-400">
                            <FontAwesomeIcon icon={faLinkedin} />
                        </a>
                        <a href="https://www.linkedin.com/in/drishtiiasvideos/" className="hover:text-blue-400">
                            <FontAwesomeIcon icon={faInstagram} />
                        </a>
                        <a href="https://www.linkedin.com/in/drishtiiasvideos/" className="hover:text-blue-400">
                            <FontAwesomeIcon icon={faYoutube} />
                        </a>
                    </div>
                </div>

                <div>
                    <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
                    <p className="text-blue-300">Except National Holidays</p>
                    <br />
                    <p className="text-blue-300">
                        <a href="tel:8750187501">+91-87501-87501</a> <br />
                        Email: care@groupdrishti.in <br />
                        21, Pusa Rd, WEA, Karol Bagh,<br />
                         Delhi-110005
                    </p>
                </div>
            </div>

            <div className="mt-16 border-t border-light-300 pt-8">
                <div className="container mx-auto flex flex-col md:flex-row justify-between items-center px-4 md:px-6">
                    <p className="text-blue-300">
                        &copy; 2018 - {currentYear} | <a href="#">Drishti Learning App</a> | All rights reserved.
                    </p>
                    <ul className="flex flex-wrap justify-center md:justify-end gap-4 md:gap-6 text-blue-300 mt-4 md:mt-0">
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                About Us
                            </a>
                        </li>
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                Methodology
                            </a>
                        </li>
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                Terms of Use
                            </a>
                        </li>
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                Privacy Policy
                            </a>
                        </li>
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                Disclaimer
                            </a>
                        </li>
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                Copyright
                            </a>
                        </li>
                        <li>
                            <a href="#" className="hover:text-blue-400">
                                Contact Us
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
